import { Component, OnInit, TemplateRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FileUploader } from "ng2-file-upload";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ContactService } from './../../services/contact.service';
import { SoaImageService } from './../../services/soa-image.service';
import { CompanyService } from './../../services/company.service';
import { EncrDecrService } from './../../services/encr-decr.service';
import html2canvas from 'html2canvas';
import { DatePipe } from '@angular/common';
import { count } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';

import Swal from 'sweetalert2/dist/sweetalert2.js';

import * as jsPDF from 'jspdf';
declare var $: any;
import 'rxjs/add/operator/map'
import { saveAs } from 'file-saver';

import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-edit-mobile',
  templateUrl: './edit-mobile.component.html',
  styleUrls: ['./edit-mobile.component.css']
})
export class EditMobileComponent implements OnInit {
  modalRef: BsModalRef;
  config: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-lg'
  };

  config1: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-xl'
  };
  config2: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };
  config3: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-xl'
  };

  /// multiple file upload  code start
  uploadForm: FormGroup;

  public uploader: FileUploader = new FileUploader({
    isHTML5: true
  });
  ////end
  fileName: string;
  filePreview: string

  folderid: any = '';
  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  customerList: object = [];
  model: any = { customer: '', reference_number: '', po_number: '', work_week: '', load_number: '', user_per: '', mobile_invoice_number: '' };

  page: number = 1;
  totalPages: number;
  isLoaded: boolean = false;
  isActive: false;
  uploaddocform: FormGroup;
  folderImageList: object = [];
  folderDocList: object = [];
  imageDiv: boolean = true;
  delete_id: number = 0;
  filePath: any = 'assets/images/loader.gif';
  pdfSrc: string = '';

  imagepfdfSrc: string = '';

  fileModel: any = {};
  canvasmode: boolean = false;
  factmodel: object = {};

  factInstructions: any = '';
  factAssigned_notice: any = '';
  factFinance_company: any = '';
  factFact_address1: any = '';
  factFact_city_state: any = '';
  factFact_email: any = '';
  mergeStatus: boolean = false;
  merge_delete_id: any = 0;
  mergeActionStatus: boolean = false;
  loaderMode: boolean = false;
  display: any = 'none';
  customer_id: any = 0;
  emailModel: any = {};
  random: any = 0;

  loaderCount: any = 0;
  currentUserRole: any = '';
  abc: any = [];
  validFolderError: any = false;
  nonfactmode: any = 1;
  privatemode: any = 1;
  isMobFolderInfoChange: any = false;

  isInvoiceNumFill: any = false;

  folder_id_e: any = 0;
  emailModal: any = true;
  emailModalError: any = false;

  folderCustMode: any = false;

  imagesCount: number = 0;
  pdfCount: number = 0;

  userList = [];
  selectedUsers: any = [];
  userDropdownSettings = {};
  check_per_mode: boolean = false;
  user_per: any = '';

  assign_fact_check_css: any = 'block';

  uploadFileUrl: any = [];

  maxDate: Date;

  constructor(private _router: Router, private _contact: ContactService,
    private _soaImage: SoaImageService,
    private _company: CompanyService,
    private modalService: BsModalService,
    private toastr: ToastrService, private _activatedroute: ActivatedRoute,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private _user: UserService,
    private _companyService: CompanyService, private http: HttpClient, private datePipe: DatePipe, private EncrDecr: EncrDecrService) { }

  folderid_encrypt: any;

  ngOnInit() {
    this.maxDate = new Date();
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');

    this.abc = localStorage.getItem('currentUser');
    var obj = JSON.parse(this.abc);

    this.currentUserRole = localStorage.getItem('role_name'); //obj.data.role_name;

    //get customer for mobile and other role user
    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
    }
    this._contact.getAssignContactListByid(customerModal)
      .subscribe(
        res => {
          // if(res.status==true){ 
          this.customerList = res;
          //}
        },
      );
    ////end
    this._activatedroute.params.subscribe(params => {
      this.folderid = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
      this.folder_id_e = params['id'];
      this.folderid_encrypt = params['id'];
    });

    this.getFolderInfo(this.folderid);

    this.uploadForm = this.fb.group({
      document: [null, null],
      folder_id: [],
      mobile_number: [],
    });

    this.uploadForm.get('folder_id').setValue(this.folderid);

    //// get folder file
    this.getFolderImage(this.folderid, 'image');
    this.getFolderDocument(this.folderid, 'document');
    this.get_company_by_id();
    this.random = this.getRandomInt(1000);

    $(document).on("click", '.selected-item', function (event) {
      $('#saveUserNameCheckBox').prop('checked', false);
    });

    $(document).on("click", '.multiselect-item-checkbox', function (event) {
      $('#saveUserNameCheckBox').prop('checked', false);
    });

    this.userDropdownSettings = {
      singleSelection: false,
      enableCheckAll: false,
      idField: 'id',
      textField: 'user_fullname',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.getUserListMob('normal');
    this.getSelectedUser();

    /*$(function(){ 
      $(".select2").select2({
        placeholder: "Select"
      });
    });*/
  }

  scrollToTop() {
    (function smoothscroll() {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - (currentScroll / 30));
      }
    })();
  }



  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  openModalBtn() {
    this.display = 'block';
  }

  onCloseHandled() {
    this.display = 'none';
  }

  getCustomerEmail() {
    this.emailModalError = false;
    this.loaderMode = true;
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      customer_id: this.customer_id,
    }

    this._contact.getContactEmailsByid(folderModel).subscribe(
      res => {
        if (this.currentUserRole != 'Mobile User' && this.model.customer_id != 0) {
          this.openModalBtn();
          if (res.data.assign_fact == '3') {
            this.assign_fact_check_css = 'none';
          }
        }
        this.loaderMode = false;
        this.emailModel = res.data;
      },
    );
  }


  //////get folder details 
  getFolderInfo(folderid) {
    this.loaderMode = true;
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      mobile_id: folderid,
    }

    this._soaImage.getFolderInfo(folderModel).subscribe(
      res => {
        this.loaderMode = false;

        if (res.data.mobile_invoice_number == '') {
          this.isInvoiceNumFill = true;
        }

        if (res.data.assign_fact == '1' || res.data.assign_fact == '2') {
          this.nonfactmode = 0;
        }
        if (res.data.p_status == 'Yes' && this.currentUserRole == 'Mobile User') {
          this._router.navigate(["/mobile/mobile-list"]);
        }
        else {
          this.privatemode = 0;
        }

        this.customer_id = res.data.customer_id;
        if (res.data.merge_pdf_path != '') {
          this.mergeStatus = true;
          this.mergeActionStatus = true;
        }

        //hide by deepak on 22/097/2022
        /*if (res.data.soa_email == 'No' && res.data.merge_pdf_path != '') {
          this.getCustomerEmail();
        }*/

        if (res.data.user_per == 'all') {
          this.check_per_mode = true;
        }

        this.model = res.data;

        $(".select2").val(res.data.customer).trigger('change');

      },
    );
  }
  ////end

  redirectMobileList() { }

  sendEmailToCust() {
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      email_info: this.emailModel,
      folder_id: this.folderid,
    }

    this._soaImage.sendEmailToCustomer(folderModel).subscribe(
      res => {
        this.modalRef.hide();
        if (res.status == true) {
          this.toastr.success(res.message, 'Success');
        } else {
          this.toastr.error(res.message, 'Error');
        }
        this.emailModal = false;
        // if(this.nonfactmode==0){
        //   this._router.navigateByUrl('/mobile/factoring-invoice/' + this.folder_id_e);
        // }
      },
    );

  }

  captureScreen() {
    var data = document.getElementById('canvas');
    html2canvas(data).then(function (canvas) {
      // var generatedImage = canvas.toDataURL("image/png");
      var generatedImage = canvas.toDataURL("image/png").replace(/^data:image\/[^;]/, 'data:application/octet-stream');
      localStorage.setItem('image64data', generatedImage);

      var link = document.createElement("a");
      link.download = "MaSimulation.png";
      link.href = generatedImage;
      document.body.appendChild(link);
      // link.click();  
    });

    setTimeout(() => {
      this.canvasmode = false;
    }, 300);
  }

  //////model function
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  openModal3(template: TemplateRef<any>) {
    this.pdfSrc = '';
    this.modalRef = this.modalService.show(template, this.config3);
  }

  openModal1(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config1);
  }

  openModal2(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config2);
  }

  setFilePath(filepath) {
    this.filePath = filepath;
  }

  setDocFilePath(filepath) {
    this.pdfSrc = filepath;
  }

  setEdiFileValue(name, id) {
    this.fileModel['filename'] = name;
    this.fileModel['fileid'] = id;
  }

  onSubmitFile() {
    this.fileModel['APIKEY'] = this.APIKEY;
    this.fileModel['user_id'] = this.user_id;
    this.fileModel['folder_id'] = this.folderid;
    this.fileModel['company_id'] = this.company_id;

    this._soaImage.updateFolderFileName(this.fileModel)
      .subscribe(
        res => {
          var encrypted = this.EncrDecr.set(localStorage.getItem('key'), this.folderid);
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/mobile/edit-mobile/' + encrypted);
          });
          this.modalRef.hide();
        },
      );
  }

  ////end
  /// multiple file upload code start
  queue_length: any;


  uploadSubmit() {
    this.loaderMode = true;
    this.queue_length = this.uploader.queue.length;

    if (this.uploader.queue.length > 0) {
      for (let i = 0; i < this.uploader.queue.length; i++) {
        let fileItem = this.uploader.queue[i]._file;
        if (fileItem.size > 9999999999999999) {
          alert("Each File should be less than 10 MB of size.");
          return;
        }

        if (i + 1 == this.uploader.queue.length) {
          var successFileCount = 0;
          var $this = this;
          var j = 0;
          testFun(j);

          $this.uploadFileUrl = [];

          function testFun(j) {
            "use strict";
            if (j < $this.uploader.queue.length) {

              let data = new FormData();
              let fileItem = $this.uploader.queue[j]._file;

              data.append('file', fileItem);
              data.append('fileSeq', 'seq' + j);
              data.append('APIKEY', $this.APIKEY);
              data.append('user_id', $this.user_id);
              data.append('company_id', $this.company_id);
              data.append('folder_id', $this.uploadForm.controls.folder_id.value);

              $this.uploadFile(data).subscribe(res => {
                successFileCount = successFileCount + res.count;
                $this.uploadFileUrl.push(res.return_url);

                if (j + 1 == $this.uploader.queue.length) {
                  $this.loaderMode = false;
                  $this.getFolderImage($this.folderid, 'image');
                  $this.getFolderDocument($this.folderid, 'document');
                  $this.getCompanyFactEmail();
                  $this.sendnotification($this.uploadFileUrl);
                  $this.uploader.clearQueue();
                } else {
                  j++;
                  testFun(j);
                }
              });
            }
          }
        }
      }
    } else {
      this.loaderMode = false;
      alert("Please select file");
    }
  }

  /*loaderClose(successFileCount,totalFileCount,Files){
      this.loaderMode = true;
      if(successFileCount==totalFileCount){
        this.sendnotification(Files);
        this.loaderMode = false;
      }
  }*/

  sendnotification(Files) {
    let encrypted = this.EncrDecr.set(localStorage.getItem('key'), this.folderid);

    if (Files.length > 0) {
      const data = {
        APIKEY: this.APIKEY,
        user_id: this.user_id,
        folder_id: this.folderid,
        company_id: this.company_id,
        customer: this.model.customer,
        customer_name: this.model.customer_name,
        customer_id: this.model.customer_id,
        work_week: this.datePipe.transform(this.model['work_week'], 'MM/dd/yyyy, hh:mm a'),
        uploader: this.queue_length,
        uploadFileUrl: Files,
        encrypted: encrypted
      }

      this._soaImage.sendnotification(data)
        .subscribe(
          res => {
            //this.loaderMode = false;
            this.uploadFileUrl = [];
          },
        );
    } else {
      this.loaderMode = false;
      alert("Please select file");
    }
  }


  soaemailModel: any = {};

  getCompanyFactEmail() {
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
    }

    this._companyService.getCompanyById(folderModel).subscribe(
      res => {
        this.soaemailModel['billing_email'] = res.data.fact_email;
        this.soaemailModel['ccemail'] = res.data.cc_email;
        this.soaemailModel['fact_id'] = res.data.fact_id;
      },
    );
  }

  uploadFile(data: FormData): Observable<any> {
    //return this.http.post<any>('http://localhost/acs_ccc-soa-v2/rest_api/api/SoaImage/uploadFolderDoc', data);
    return this.http.post<any>('https://factor-ccc-soa.mybizpad.com/rest_api/api/SoaImage/uploadFolderDoc', data);
  }

  /// multiple file upload  code end
  //// get folder file
  getFolderImage(folderid, type) {
    const fileModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      folder_id: this.folderid,
      type: type,
      company_id: this.company_id,
    }
    this._soaImage.getFolderFileList1(fileModal)
      .subscribe(
        res => {
          this.imagesCount = res.length;
          this.folderImageList = res;
        },
      );
  }

  getFolderDocument(folderid, type) {
    const fileModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      folder_id: this.folderid,
      type: type,
      company_id: this.company_id,
    }
    this._soaImage.getFolderFileList1(fileModal)
      .subscribe(
        res => {
          this.pdfCount = res.length;
          this.folderDocList = res;
        },
      );
  }
  // end folder file 


  //ajax submit folder information when upload files
  demo: any = [];
  selectedIds: any = [];

  onSubmitMFolderAjax(f) {
    this.model['APIKEY'] = this.APIKEY;
    this.model['user_id'] = this.user_id;
    this.model['folder_id'] = this.folderid;
    this.model['company_id'] = this.company_id;
    this.model['Additional_access'] = JSON.stringify(this.selectedUsers);
    this.model['user_per'] = this.user_per;

    this.model['customer'] = $(".select2").val();

    if (this.model['customer'] == '' || this.model['customer'] == 0) {

    } else {
      var s = $(".select2").val().split('-');
      this.model['customer_id'] = s[0];
      this.model['customer_name'] = s[1];
    }

    if (this.model['reference_number'] == ''
      && this.model['po_number'] == ''
      && this.model['work_week'] == ''
      && this.model['load_number'] == '' && this.model['mobile_invoice_number'] == ''
    ) {
      this.validFolderError = true;
      return false;
    }
    else {
      this.model['work_week'] = this.datePipe.transform(this.model['work_week'], 'MM/dd/yyyy, hh:mm a');
      this.validFolderError = false;
      this._soaImage.updateMobileFolder(this.model)
        .subscribe(
          res => {

            //code added by deepak on 13June2022
            if (this.model['mobile_invoice_number'] == '') {
              this.isInvoiceNumFill = true;
            } else {
              this.isInvoiceNumFill = false;
            }
            //end

            this.isMobFolderInfoChange = false;
            this.toastr.success(res.message, 'Success');
          },
        );
    }
  }

  //send edit mobile link to all mobile users
  // send_sms_to_additional_user() {

  //   const data = {
  //     APIKEY: this.APIKEY,
  //     company_id: this.company_id,
  //     folderid: this.folderid,
  //     user_id: this.user_id,
  //     selectedUsers: JSON.stringify(this.selectedUsers),
  //     encrypted: this.EncrDecr.set(localStorage.getItem('key'), this.folderid)
  //   }

  //   if (this.selectedUsers.length > 0) {
  //     this._user.sendSmsToAdditionalUser(data)
  //       .subscribe(
  //         res => {
  //           if (res.status == true) {
  //             this.toastr.success(res.message, 'Success');
  //           } else {
  //             this.toastr.error(res.message, 'Error');
  //           }
  //         },
  //         err => console.log(err)
  //       );
  //   } else {
  //     this.toastr.error('User not selected', 'Error');
  //   }

  // }
  //send edit mobile link to all Professional Users
  send_sms_to_additional_user() {
    const data = {
      APIKEY: this.APIKEY,
      company_id: this.company_id,
      folderid: this.folderid,
      user_id: this.user_id,
      selectedUsers: JSON.stringify(this.selectedUsers),
      encrypted: this.EncrDecr.set(localStorage.getItem('key'), this.folderid),
      Additional_access: JSON.stringify(this.selectedUsers),
      customer_id: this.customer_id
    }

    if (this.selectedUsers.length > 0) {
      this._user.sendSmsToAdditionalUser(data)
        .subscribe(
          res => {
            if (res.status == true) {
              this.toastr.success(res.message, 'Success');
            } else {
              this.toastr.error(res.message, 'Error');
            }
          },
          err => console.log(err)
        );
    } else {
      this.toastr.error('User not selected', 'Error');
    }

  }

  set_delete_id(cid) {
    this.delete_id = cid;
  }

  set_delete_merge_id(id) {
    this.merge_delete_id = id;
  }

  delete_mergefile() {
    const data = {
      delete_id: this.delete_id,
      APIKEY: this.APIKEY,
      mobile_id: this.merge_delete_id,
    }

    this._soaImage.deleteMergeFile(data)
      .subscribe(
        res => {
          this.toastr.success(res.message, 'Success');
          // this.getFolderDocument(this.folderid,'document');
          // this.getFolderImage(this.folderid,'image');
          this.mergeActionStatus = false;
          this.getFolderInfo(this.folderid);


        },
        err => console.log(err)
      );
  }
  /////set 

  //code added by deepak on 13June2022
  check_req_field($event) {
    if ($event.target.value == '') {
      this.isInvoiceNumFill = true;
      this.isMobFolderInfoChange = false;
    } else {
      this.isInvoiceNumFill = false;
      this.isMobFolderInfoChange = true;
    }
  }
  //end

  omit_special_char(event) {
    var k;
    k = event.charCode;
    //k = event.keyCode;  (Both can be used)
    this.isMobFolderInfoChange = true;
    this.isInvoiceNumFill = false;
    return ((k >= 48 && k <= 57) || (k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 45);
  }

  delete_user() {
    const data = {
      delete_id: this.delete_id,
      APIKEY: this.APIKEY,
      user_id: this.user_id,
    }

    this._soaImage.deleteFolderFile(data)
      .subscribe(
        res => {
          this.toastr.success(res.message, 'Success');
          this.getFolderDocument(this.folderid, 'document');
          this.getFolderImage(this.folderid, 'image');
        },
        err => console.log(err)
      );
  }
  /////set 

  rotateFolderFile(filePath) {
    this.filePath = filePath;
  }

  rotate_file() {
    const data = {
      file_path: this.filePath,
      APIKEY: this.APIKEY,
      user_id: this.user_id,
    }

    this._soaImage.rotateFolderFile(data)
      .subscribe(
        res => {
          this.random = this.getRandomInt(1000);
          this.toastr.success(res.message, 'Success');
          this.getFolderDocument(this.folderid, 'document');
          this.getFolderImage(this.folderid, 'image');
          // this._router.navigateByUrl('/redirect').then(() => {
          // this._router.navigateByUrl('/mobile/edit-mobile/'+this.folderid);
          //});
        },
        err => console.log(err)
      );
  }

  get_company_by_id() {
    const data = {
      company_id: this.company_id,
      APIKEY: this.APIKEY
    }

    this.canvasmode = true;
    this._company.getCompanyById(data)
      .subscribe(
        res => {
          this.factmodel = res.data;
          this.factInstructions = res.data.instructions;
          this.factAssigned_notice = res.data.assigned_notice;
          this.factFinance_company = res.data.finance_company;
          this.factFact_address1 = res.data.fact_address1;
          this.factFact_city_state = res.data.fact_city_state;
          this.factFact_email = res.data.fact_email;

          setTimeout(() => {    //<<<---    using ()=> syntax
            this.captureScreen();
          }, 200);
        },
        err => console.log(err)
      );
  }

  redirectedinto(folderid) {
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), folderid);
    this._router.navigate(["/mobile/factoring-invoice/" + encrypted]);
  }


  redirected(folderid) {
    // this condition added by deepak on 22/07/2022
    if (this.imagesCount == 0 && this.pdfCount == 0) {
      alert('Please Upload Documents For Merge File');
      return false;
    } else {
      var encrypted = this.EncrDecr.set(localStorage.getItem('key'), folderid);
      this._router.navigate(["/mobile/file-merge/" + encrypted]);
    }

    //var encrypted = this.EncrDecr.set(localStorage.getItem('key'), folderid);  
    //this._router.navigate(["/mobile/file-merge/"+encrypted]);

  }


  setpdfPath(filepath) {
    this.filePath = filepath;
  }

  //create imgae to pdf code here 
  setFilePDF(filepath, id) {
    this.filePath = filepath;
    const fileModalPDF = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      file_id: id,
      company_id: this.company_id,
      filepath: this.filePath,
    }

    this._soaImage.imageConvertPdf(fileModalPDF)
      .subscribe(
        res => {
          this.pdfSrc = res;
          //this.modalRef = this.modalService.show('viewPDFDocFile',this.config3); 
        },
      )
  };

  getUserListMob(mode) {
    const data = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active'
    };

    this._user.getuserListByIdMob(data)
      .subscribe(
        res => {
          if (res.status == true) {
            if (mode == 'custper') {
              this.selectedUsers = res.data;
            }
            this.userList = res.data;
          }

        },
      );
  }

  getSelectedUser() {
    const data = {
      APIKEY: this.APIKEY,
      folder_id: this.folderid,
      company_id: this.company_id,
      //status: 'active'
    };
    this._soaImage.getAdditionalMobileUsers(data).subscribe(
      res => {
        this.selectedUsers = res['data'];
      }
    );
  }

  onCustomerPer(value: boolean) {
    if (value != true) {
      this.selectedUsers = [];
      this.user_per = '';
    }
    else {
      const mode = 'custper';
      this.getUserListMob(mode);
      this.user_per = 'all';
    }
  }


  viewString: any;
  prestring: any;
  onViewSelect(item: any) {
    this.isMobFolderInfoChange = true;
  }

  onItemSelect(item: any) {

  }

  onItemSelectAll(items: any) {

  }

  downloadimage(url) {
    var fileName = url.substring(url.lastIndexOf("/") + 1, url.length);
    this.http.get(url, { responseType: 'blob' }).subscribe(
      (d: any) => {
        saveAs(d, fileName);
      },
      (err: any) => {
        console.log("error", err)
      }
    )
  }

  downloadpdf(url) {
    var fileName = url.substring(url.lastIndexOf("/") + 1, url.length);
    this.http.get(url, { responseType: 'blob' }).subscribe(
      (d: any) => {
        saveAs(d, fileName);
      },
      (err: any) => {
        console.log("error", err)
      }
    )

  }



}